import { PropsWithChildren, useState } from 'react'

import { useBoolean, useUpdateEffect } from 'ahooks'
import { Button, ColorPicker, Divider } from 'antd'
import { createStyles } from 'antd-style'

import { FontColorPickerProps } from './interface'

const presetColors = [
  'rgb(255, 255, 255)',
  'rgb(0, 0, 0)',
  'rgb(231, 230, 230)',
  'rgb(68, 84, 106)',
  'rgb(91, 155, 213)',
  'rgb(237, 125, 49)',
  'rgb(165, 165, 165)',
  'rgb(255, 192, 0)',
  'rgb(68, 114, 196)',
  'rgb(112, 173, 71)',
  'rgb(242, 242, 242)',
  'rgb(128, 128, 128)',
  'rgb(208, 206, 206)',
  'rgb(214, 220, 229)',
  'rgb(222, 235, 247)',
  'rgb(251, 229, 214)',
  'rgb(237, 237, 237)',
  'rgb(255, 242, 204)',
  'rgb(218, 227, 243)',
  'rgb(226, 240, 217)',
  'rgb(217, 217, 217)',
  'rgb(89, 89, 89)',
  'rgb(175, 171, 171)',
  'rgb(173, 185, 202)',
  'rgb(189, 215, 238)',
  'rgb(248, 203, 173)',
  'rgb(219, 219, 219)',
  'rgb(255, 230, 153)',
  'rgb(180, 199, 231)',
  'rgb(197, 224, 180)',
  'rgb(191, 191, 191)',
  'rgb(64, 64, 64)',
  'rgb(118, 113, 113)',
  'rgb(132, 151, 176)',
  'rgb(157, 195, 230)',
  'rgb(244, 177, 131)',
  'rgb(201, 201, 201)',
  'rgb(255, 217, 102)',
  'rgb(143, 170, 220)',
  'rgb(169, 209, 142)',
  'rgb(166, 166, 166)',
  'rgb(38, 38, 38)',
  'rgb(59, 56, 56)',
  'rgb(51, 63, 80)',
  'rgb(46, 117, 182)',
  'rgb(197, 90, 17)',
  'rgb(124, 124, 124)',
  'rgb(191, 144, 0)',
  'rgb(47, 85, 151)',
  'rgb(84, 130, 53)',
  'rgb(127, 127, 127)',
  'rgb(13, 13, 13)',
  'rgb(24, 23, 23)',
  'rgb(34, 42, 53)',
  'rgb(31, 78, 121)',
  'rgb(132, 60, 11)',
  'rgb(83, 83, 83)',
  'rgb(127, 96, 0)',
  'rgb(32, 56, 100)',
  'rgb(56, 87, 35)'
]

const standardColors = [
  'rgb(192, 0, 0)',
  'rgb(255, 0, 0)',
  'rgb(255, 192, 0)',
  'rgb(255, 255, 0)',
  'rgb(146, 208, 80)',
  'rgb(0, 176, 80)',
  'rgb(0, 176, 240)',
  'rgb(0, 112, 192)',
  'rgb(0, 32, 96)',
  'rgb(112, 48, 160)'
]

const presets = [
  {
    label: '预设颜色',
    colors: presetColors
  },
  {
    label: '标准颜色',
    colors: standardColors
  }
]

const useStyles = createStyles(({ token }) => ({
  autoBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    lineHeight: 1,
    width: '100%'
  },
  autoIcon: {
    position: 'relative',
    display: 'inline-block',
    width: 18,
    height: 18,
    borderRadius: token.borderRadiusSM
  },
  panel: {
    width: 360
  }
}))

export const FontColorPicker = ({
  /* -------------------------------------------------------------------------- */
  /*                            FontColorPicker Props                           */
  /* -------------------------------------------------------------------------- */
  children,
  defaultValue,
  value,
  onChange,

  /* -------------------------------------------------------------------------- */
  /*                              ColorPicker Props                             */
  /* -------------------------------------------------------------------------- */
  ...colorPickerProps
}: PropsWithChildren<FontColorPickerProps>) => {
  const [open, openActions] = useBoolean(false)
  const [pickerValue, setPickerValue] = useState(value)

  useUpdateEffect(() => {
    if (value !== pickerValue) {
      setPickerValue(value)
    }
  }, [value])

  const handleOpenChange = (open: boolean) => {
    openActions.set(open)
    if (!open) {
      onChange(pickerValue)
    }
  }

  const { styles } = useStyles()

  return (
    <ColorPicker
      {...colorPickerProps}
      open={open}
      presets={presets}
      value={pickerValue}
      panelRender={(_, { components: { Picker, Presets } }) => (
        <div className={styles.panel}>
          <Button
            className={styles.autoBtn}
            type='text'
            icon={
              <span
                className={styles.autoIcon}
                style={{
                  backgroundColor: defaultValue
                }}
              />
            }
            onClick={() => setPickerValue(defaultValue)}
          >
            默认颜色
          </Button>
          <Divider orientation='horizontal' style={{ margin: '8px 0' }} />
          <Presets />
          <Picker />
        </div>
      )}
      onChange={(_, cssColor) => setPickerValue(cssColor)}
      // onChangeComplete={openActions.setFalse}
      onOpenChange={handleOpenChange}
    >
      {children}
    </ColorPicker>
  )
}
